{
  "share_project": "Share project",
  "message": "message",
  "send_invitation": "send invitation",
  "email": "Email",
  "invite_creators": "Invite creators"
}
